(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = this.closest('.section-header');
      this.isScrolled = false;
      this.scrollThreshold = 100;
      this.isHomePage = document.body.classList.contains('template-index') || 
                       window.location.pathname === '/';
    }
    
    connectedCallback() {
      if (!this.header) {
        console.warn('Header element not found');
        return;
      }
      
      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      
      this.initializeHeader();
      this.handleScroll();
    }
    
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }
    
    initializeHeader() {
      if (this.isHomePage) {
        this.header.style.position = 'absolute';
        this.header.style.top = '0';
        this.header.style.left = '0';
        this.header.style.right = '0';
        this.header.style.zIndex = '1000';
        this.header.classList.remove('scrolled');
      } else {
        this.header.style.position = 'fixed';
        this.header.style.top = '0';
        this.header.style.left = '0';
        this.header.style.right = '0';
        this.header.style.zIndex = '1000';
      }
    }
    
    onScroll() {
      requestAnimationFrame(() => this.handleScroll());
    }
    
    onResize() {
      this.handleScroll();
    }
    
    handleScroll() {
      if (!this.isHomePage) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeScrolled = scrollTop > this.scrollThreshold;
      
      if (shouldBeScrolled && !this.isScrolled) {
        this.isScrolled = true;
        this.header.classList.add('scrolled');
        this.header.style.position = 'fixed';
        
        document.body.style.paddingTop = `${this.header.offsetHeight}px`;
        
      } else if (!shouldBeScrolled && this.isScrolled) {
        this.isScrolled = false;
        this.header.classList.remove('scrolled');
        this.header.style.position = 'absolute';
        
        document.body.style.paddingTop = '0';
      }
    }
  }
  
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
